import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  savePesticideManufacturer: ['manufacturer', 'onSuccess', 'onError'],
  savePesticide: ['pesticide', 'onSuccess', 'onError'],
  removePesticide: ['pesticide', 'onSuccess', 'onError'],
  pesticideError: ['error']
})

const savePesticideManufacturer = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const savePesticide = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removePesticide = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const pesticideError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.PESTICIDE_ERROR]: pesticideError,

  [Types.SAVE_PESTICIDE_MANUFACTURER]: savePesticideManufacturer,

  [Types.SAVE_PESTICIDE]: savePesticide,
  [Types.REMOVE_PESTICIDE]: removePesticide,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as PesticideTypes,
  Creators as PesticideActions
}
